import { ITagWithGroup } from '../types';
import { ISimpleOption } from 'src/views/Admin/types';

const nonDuplicatable = (tag: ITagWithGroup) =>
  tag.tagGroup.allowDuplicateOnItemLevel === 'DenyDuplicate';

export const availableTagGroups = (
  tags: ITagWithGroup[],
  options: ISimpleOption[]
) => {
  const nonDuplicatableTags = tags.filter(nonDuplicatable);
  const filteredOptions = options.filter(option => {
    return !nonDuplicatableTags.find(
      ({ tagGroup }) => tagGroup.id === option.value.id
    );
  });
  return filteredOptions;
};



// WEBPACK FOOTER //
// ./src/views/Admin/Items/services/availableTagGroups.ts